import './Tests.css';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Tests() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // تحديد نوع الاختبار من المسار
  const getTestType = () => {
    if (location.pathname.includes('icdl')) return 'icdl';
    if (location.pathname.includes('ielts')) return 'ielts';
    if (location.pathname.includes('toefl')) return 'toefl';
    return 'icdl';
  };

  const testType = getTestType();

  // محتوى مختلف لكل اختبار
  const content = {
    icdl: {
      title: 'شهادة الرخصة الدولية',
      subtitle: 'لقيادة الحاسوب (ICDL)',
      description: 'تضمن قدرات مستخدمين الحاسب الآلي ويُرشح متعلميها إنَّهم قادرين على إختيار أعمالهم الوظيفية',
      description2: 'فهم يتمكن من مجموعة من البرامج الأساسية التي يحتاج إليها أي مستخدم'
    },
    ielts: {
      title: 'شهادة IELTS',
      subtitle: 'نظام اختبار اللغة الإنجليزية الدولي',
      description: 'اختبار اللغة الإنجليزية الأكثر شهرة في العالم للتعليم العالي والهجرة العالمية',
      description2: 'يقيم مهاراتك في الاستماع والقراءة والكتابة والمحادثة باللغة الإنجليزية'
    },
    toefl: {
      title: 'شهادة TOEFL',
      subtitle: 'اختبار اللغة الإنجليزية كلغة أجنبية',
      description: 'اختبار معترف به عالمياً لقياس قدرتك على استخدام وفهم اللغة الإنجليزية',
      description2: 'مقبول من قبل أكثر من 11,000 جامعة ومؤسسة في أكثر من 150 دولة'
    }
  };

  return (
    <div className="tests-page">
      {/* Header Space */}
      <div className="header-spacer"></div>

      {/* Hero Section */}
      <section className="tests-hero">
        <div className="hero-shapes">
          <div className="shape-circle shape-1"></div>
          <div className="shape-circle shape-2"></div>
          <div className="shape-circle shape-3"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge-wrapper">
              <span className="hero-badge">
                <span className="badge-text">شهادات دولية</span>
                <span className="badge-icon">🏆</span>
              </span>
            </div>
            <h1 className="tests-hero-title">{content[testType].title}<br/>{content[testType].subtitle}</h1>
            <div className="title-decoration"></div>
            <p className="tests-hero-description">
              {content[testType].description}<br/>
              {content[testType].description2}
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      {testType === 'icdl' && (
      <section className="tests-content">
        <div className="container">
          
          {/* Introduction Card */}
          <div className="intro-card">
            <div className="intro-icon">💻</div>
            <p className="intro-text">
              تضمن قدرات مستخدمين الحاسب الآلي ويُرشح متعلميها إنكِهم قادرين على إختيار أعمالهم الوظيفية فهم يتمكن من مجموعة من البرامج الأساسية التي يحتاج إليها أي مستخدم، كما أنها أصبحت من الشهادات العالمية المعتمدة ومن المتطلبات الأساسية في أي مؤسسة حكومية أو خاصة لأي وظيفة من الوظائف.
            </p>
          </div>

          {/* Certificates Grid */}
          <div className="certificates-grid">
            
            {/* ICDL Base */}
            <div className="certificate-card">
              <div className="certificate-header">
                <div className="certificate-icon">🎯</div>
                <h3 className="certificate-title">الشهادة الأساسية ICDL Base</h3>
              </div>
              <div className="certificate-body">
                <p className="certificate-description">
                  تحتوي على 4 مقررات وهي:
                </p>
                <ul className="certificate-modules">
                  <li>
                    <span className="module-icon">✓</span>
                    <span>أساسيات الكمبيوتر</span>
                  </li>
                  <li>
                    <span className="module-icon">✓</span>
                    <span>مفاهيم التصفح</span>
                  </li>
                  <li>
                    <span className="module-icon">✓</span>
                    <span>معالج النصوص</span>
                  </li>
                  <li>
                    <span className="module-icon">✓</span>
                    <span>جداول البيانات</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* ICDL Productivity */}
            <div className="certificate-card featured">
              <div className="featured-badge">الأكثر طلباً</div>
              <div className="certificate-header">
                <div className="certificate-icon">🚀</div>
                <h3 className="certificate-title">الشهادة الإنتاجية ICDL Productivity</h3>
              </div>
              <div className="certificate-body">
                <p className="certificate-description">
                  تحتوي على 7 مقررات وهي شهادة 3 = ICDL Base + مهارات تطبيقية مثل:
                </p>
                <ul className="certificate-modules">
                  <li>
                    <span className="module-icon">✓</span>
                    <span>التعريف بالقيمة</span>
                  </li>
                  <li>
                    <span className="module-icon">✓</span>
                    <span>التعريف عبر الإنترنت</span>
                  </li>
                  <li>
                    <span className="module-icon">✓</span>
                    <span>أمن تكنولوجيا المعلومات</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* ICDL Applied */}
            <div className="certificate-card">
              <div className="certificate-header">
                <div className="certificate-icon">⚡</div>
                <h3 className="certificate-title">الشهادات التطبيقية ICDL Applied</h3>
              </div>
              <div className="certificate-body">
                <p className="certificate-description">وهي بادئات متنوعة مثل:</p>
                <ul className="certificate-modules">
                  <li>
                    <span className="module-icon">•</span>
                    <span>شهادات التواصل الاجتماعي - يحتوي على 3 مقررات وهي ويسلل التواصل الاجتماعى - البحث عبر الإنترنت - تأمين المبيعات والمعلومات</span>
                  </li>
                  <li>
                    <span className="module-icon">•</span>
                    <span>شهادة التعليل للنشر - يحتوي على 3 مقررات إيز تكنولوجيا المعلومات - التجارة عبر الإنترنت - تحديث المحتويات</span>
                  </li>
                  <li>
                    <span className="module-icon">•</span>
                    <span>شهادة الامن السيبراني - يحتوي على 3 بادئات وهي - امن المزن السيبراني - امن السيبراني - امن السيبراني</span>
                  </li>
                  <li>
                    <span className="module-icon">•</span>
                    <span>شهادة التكاة الصطناعي - يحتوي عبن عقود من التكاة الصطناعي</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>

          {/* Notes Section */}
          <div className="notes-section">
            <h3 className="notes-title">
              <span className="notes-icon">📌</span>
              ملاحظات
            </h3>
            <div className="notes-content">
              <div className="note-item">
                <span className="note-bullet">□</span>
                <p>يمكن للمتدربين دراسة أجندة البادئات سواءً بشكل كاملة، بكلية رزئية أو متفرقة بأختبار أجندة البرامج</p>
              </div>
              <div className="note-item">
                <span className="note-bullet">□</span>
                <p>يمكن للمتدربين الحاصلين على ICDL بسط الشهادات هو أجندة البادئات الحديثة ويُقوبة بشهاداتهم</p>
              </div>
              <div className="note-item">
                <span className="note-bullet">□</span>
                <p>يمكن للمتدربين الذين يرغبوا في استكمال ICDL التسجيل معدنا واستكمال المقررات والحصول على الشهادة</p>
              </div>
            </div>
          </div>

        </div>
      </section>
      )}

      {/* IELTS Content */}
      {testType === 'ielts' && (
      <section className="tests-content">
        <div className="container">
          
          {/* Introduction Card */}
          <div className="intro-card">
            <div className="intro-icon">🎯</div>
            <p className="intro-text">
              مع التطور التكنولوجي والمعلوماتي الذي يشهده الحياة في القوة الجارية، أصبح من الضروري أن يتقن الإنسان العديد من المهارات سواءً كان ذلك متطلباً من الدراسة أو لأجل تأسيساً عند التقدم لطلب وظيفة أو عمل ما ومن أهم المهارات المتطلبة في أغلب هذه مهارات استخدام الحاسوب، ومهارات إتقان بعض اللغات وإهدتها الإنجليزية والفرنسية، لذا أصبح الحاجة إلى لقياس علمين معتمدين لهذه المهارات.
            </p>
          </div>

          {/* IELTS Info */}
          <div className="ielts-info-card">
            <div className="info-content">
              <div className="info-text">
                <h2 className="info-title">شهادة IELTS</h2>
                <p className="info-description">
                  اختبار أل أيُلتس للغة الإنجليزية (IELTS) وبالاسم المختصر لجملة International English Language Testing System ويعتبر "نظام اختبار اللغة الإنجليزية الدولي" يعتبر أكثر الامتحانات اعتماداً من العالم وخصوصاً في بريطانيا وأستراليا لفحص مقدرة شخص معين ومدى تمكنه من اللغة الإنجليزية.
                </p>
              </div>
              <div className="info-image">
                <img src="/18.jpg" alt="IELTS" />
              </div>
            </div>
          </div>

        </div>
      </section>
      )}

      {/* TOEFL Content */}
      {testType === 'toefl' && (
      <section className="tests-content">
        <div className="container">
          
          {/* Introduction Card */}
          <div className="intro-card">
            <div className="intro-icon">🎯</div>
            <p className="intro-text">
              مع التطور التكنولوجي والمعلوماتي الذي يشهده الحياة في القوة الجارية، أصبح من الضروري أن يتقن الإنسان العديد من المهارات سواءً كان ذلك متطلباً من الدراسة أو لأجل تأسيساً عند التقدم لطلب وظيفة أو عمل ما ومن أهم المهارات المتطلبة في أغلب هذه مهارات استخدام الحاسوب، ومهارات إتقان بعض اللغات وإهدتها الإنجليزية والفرنسية، لذا أصبح الحاجة إلى لقياس علمين معتمدين لهذه المهارات.
            </p>
          </div>

          {/* TOEFL Info */}
          <div className="ielts-info-card">
            <div className="info-content">
              <div className="info-text">
                <h2 className="info-title">شهادة TOEFL</h2>
                <p className="info-description">
                  ان اختبار توفل (اختبار اللغة الإنجليزية كلغة أجنبية) هو اختبار اللغة الإنجليزية الأكاديمي الموحد الذي يأخذه الطلاب المتقدمون للجامعات في الولايات المتحدة. يتم قبول توفل أيضا كدليل على قدرة اللغة الإنجليزية من قبل بعض الجامعات خارج الولايات المتحدة. توفل هو في الواقع مجموعة من الاختبارات، والأكثر شعبية منها هو توفل إبت. الاختبارات الأخرى في جناح توفل هي توفل ببت (اختبار الورق)، و توفل إيتب (برنامج اختبار المؤسسات)، و توفل جونيور ستاندارد، و توفل جونيور الشامل. هذه الأشكال الأخرى من توفل متوفرة فقط في مواقع معينة، أو متاحة فقط للطلاب عبر مدارسهم.
                </p>
              </div>
              <div className="info-image">
                <img src="/18.jpg" alt="TOEFL" />
              </div>
            </div>
          </div>

        </div>
      </section>
      )}

    </div>
  );
}

export default Tests;
